import useFetch from "../../hooks/useFetch";
import {useEffect, useRef, useState} from "react";
import CONFIG from "../../config/_config";
import {Button, Card, CardContent, Stack, Typography} from "@mui/material";
import SortableList from "../../components/_atoms/admin/SortableList";
import SaveIcon from '@mui/icons-material/Save';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {useNotification} from "../../store/admin/NotificationProvider";
import {useModal} from "../../store/admin/ModalProvider";


const MenuSortingPage = () => {
    const {makeRequest, response} = useFetch();
    const [categories, setCategories] = useState([]);
    const {showNotification} = useNotification();
    const items = useRef();
    const {openModal, closeModal} = useModal();
    const selectedCategory = useRef(null)

    useEffect(() => {
        makeRequest(CONFIG.adminApiUrl + 'category_ajax.php', 'post', {
            'getAllCategories': 1
        })
    }, []);

    useEffect(() => {
        if (!response)
            return;
        if (response.state === 'error') {
            const notification = {
                open: true,
                type: 'error',
            }

            if ('getAllCategories' in response.requestData) {
                notification.message = "Errore caricamento lista categorie"
            }
            if ('sortCategories' in response.requestData){
                notification.message = "Errore: ordinamento categorie non riuscito"
            }
            if ('sortProducts' in response.requestData){
                notification.message = "Errore: ordinamento prodotti non riuscito";
                closeModal();
            }
            if ('getAllCategoryProducts' in response.requestData){
                notification.message = "Errore caricamento lista prodotti"
                closeModal();
            }
            showNotification(notification);
            return;
        }
        if ('getAllCategories' in response.requestData) {
            setCategories([...response.data]);
        }
        if ('sortCategories' in response.requestData){
            showNotification({
                open: true,
                type: 'success',
                message: 'Categorie ordinate con successo'
            });
        }
        if ('sortProducts' in response.requestData){
            closeModal();
            showNotification({
                open: true,
                type: 'success',
                message: 'Prodotti ordinate con successo'
            });

        }
        if ('getAllCategoryProducts' in response.requestData){
            const products = response.data.map(p => ({
                id: p.id,
                title: p.name,
                subtitle: p.description,
                action: {
                    type: 'text',
                    text: '€' + p.price
                }
            }));

            openModal('SortableListModal', {
                title: 'Ordina Prodotti',
                subtitle: "Trascina e rilascia una categoria per cambiare l'ordine",
                items: products,
                isLoading: false,
                noDataText: "Nessun prodotto in questa categoria",
                onSubmit: (sortedItems) => {
                    const requestData = {
                        sortProducts: 1,
                        categoryId: selectedCategory.current,
                        products: sortedItems.map((item, index) => ({
                            id: item.id,
                            position_index: index
                        }))
                    };
                    makeRequest(CONFIG.adminApiUrl + 'category_ajax.php', 'post', requestData);
                }
            })
        }

    }, [response])


    items.current = categories.map(({id, name, description}) => {
        return {
            id,
            title: name,
            subtitle: description,
            action: {
                type: 'button',
                tooltip: 'Modifica Prodotti',
                onClick: () => {
                    openModal('SortableListModal', {
                        title: 'Ordina Prodotti',
                        subtitle: "Trascina e rilascia una categoria per cambiare l'ordine",
                        items: [],
                        isLoading: true,
                        loadingText: 'Caricamento lista prodotti',
                        noDataText: "Nessun prodotto in questa categoria"
                    })
                    selectedCategory.current = id;
                    makeRequest(CONFIG.adminApiUrl + 'category_ajax.php', 'post', {
                        getAllCategoryProducts: 1,
                        id
                    })
                },
                icon: <ListAltIcon />
            }
        }
    })

    const onSaveClickHandler = () => {
        const categories = items.current.map((item, index) => ({id: item.id, position_index: index}));
        makeRequest(CONFIG.adminApiUrl + 'category_ajax.php', 'post', {
            sortCategories: 1,
            categories
        })
    }

    const onItemsSort = (sortedItems) => {
        items.current = sortedItems;
    }

    return <>
        <Stack direction='column' sx={{mb: 3}}>
            <Typography variant='h4' color='primary'>Ordina Menu</Typography>
            <Typography variant='h5'>Trascina e rilascia una categoria per cambiare l'ordine</Typography>
            <Typography variant='body1' color='grey'>Clicca su <ListAltIcon /> per ordinare i prodotti di una categoria</Typography>
        </Stack>
        <Stack sx={{maxWidth: '700px'}} alignItems='flex-end'>
            <Button
                sx={{mb: 2, py: 1, px: 3, maxWidth: '150px'}}
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={onSaveClickHandler} >
                Salva
            </Button>
        </Stack>
        {categories.length === 0 && 'Caricamento in corso'}
        {categories.length > 0 &&
            <Card sx={{ maxWidth: 700 }}>
                <CardContent>
                    <SortableList items={items.current} onItemsSort={onItemsSort} />
                </CardContent>
            </Card>
        }
    </>
}

export default MenuSortingPage;